(function() {
    // In case job search page is open
    if(document.getElementById("root-amadeus-fire-search-function")) {
        //Saved jobs' toggler
        const savedJobsToggler = document.querySelectorAll('#af-menu-pwa li[data-saved-jobs-toggler="yes"] button')[0];
        if(savedJobsToggler) {
            //In case saved jobs' list is open, styles of the job search link-button should change non-active and vice versa
            function afScrollToSavedJobsAndChangeStyleOfJobSearchLink(savedJobsToggler, event = "click") {
                const timeout = event === "load" ? 500 : 0;
                setTimeout(function() {
                    const loadCheck = event === "load" ? savedJobsToggler.parentElement.className.indexOf("af-menu-item-pwa-active") > -1 : true;
                    if(savedJobsToggler.parentElement.className.indexOf("af-menu-item-pwa") > -1 && loadCheck) {
                        //Active
                        const jobSearchButton = document.querySelectorAll(".af-menu-item-pwa-active a")[0].parentElement;
                        if(jobSearchButton) {
                            const jobSearchButtonBackground = jobSearchButton.querySelectorAll("span")[0];
                            if (jobSearchButton.className.indexOf(" af-menu-item-pwa-active-override") === -1 && savedJobsToggler.parentElement.className.indexOf("af-menu-item-pwa-active") > -1) {
                                jobSearchButtonBackground.style.display = "";
                                jobSearchButton.className = jobSearchButton.className + " af-menu-item-pwa-active-override";
                            }
                            else {
                                jobSearchButton.className = jobSearchButton.className.replace(" af-menu-item-pwa-active-override","");
                                jobSearchButtonBackground.style.display = "";
                            }
                        }
                    }
                },timeout);
            }
            //On clicking on the saved jobs' toggler
            savedJobsToggler.addEventListener("click",function() {afScrollToSavedJobsAndChangeStyleOfJobSearchLink(savedJobsToggler)});
            //On loading of the page
            window.addEventListener("load",function() {afScrollToSavedJobsAndChangeStyleOfJobSearchLink(savedJobsToggler,"load")});
        }
    }
    else {
        function afOpenSavedJobs(button) {
            window.open(button.dataset.href,"_self")
        }
        const areThereSavedJobs = localStorage.getItem("afSavedJobs") ? JSON.parse(localStorage.getItem("afSavedJobs")).length > 0 : false;
        const savedJobsButton = document.querySelectorAll("#af-menu-pwa li button")[0];
        savedJobsButton.addEventListener("click",function() {afOpenSavedJobs(savedJobsButton)})
        if (areThereSavedJobs) {
            savedJobsButton.parentElement.className = "af-menu-item-pwa af-menu-item-pwa-normal";
        }
    }
    //Pwa submenu toggler
    const pwaSubmenuToggler = document.querySelectorAll("#af-pwa-sub-menu-button button")[0];
    if(pwaSubmenuToggler) {
        const closeSubMenuButton = document.getElementById("af-sub-menu-pwa-close");

        function afTogglerPwaSubmenu(pwaSubmenuToggler) {
            const subMenu = document.getElementById("af-sub-menu-pwa");
            const pwaSubmenuTogglerList = pwaSubmenuToggler.parentElement;
            if(pwaSubmenuTogglerList.className.indexOf("af-menu-item-pwa-normal") > -1) {
                pwaSubmenuTogglerList.className = pwaSubmenuTogglerList.className.replace("af-menu-item-pwa-normal","af-menu-item-pwa-active");
                subMenu.className = "";
            }
            else {
                pwaSubmenuTogglerList.className = pwaSubmenuTogglerList.className.replace("af-menu-item-pwa-active","af-menu-item-pwa-normal");
                subMenu.className = "af-sub-menu-pwa-hidden";
            }
        }

        pwaSubmenuToggler.addEventListener("click",function() {afTogglerPwaSubmenu(pwaSubmenuToggler)});

        closeSubMenuButton.addEventListener("click",function() {afTogglerPwaSubmenu(pwaSubmenuToggler)});
    }
})();
